import { PanelLeft, Search, Bell } from "lucide-react";
import IconButton from "../ui/IconButton";
import Input from "../ui/Input";

interface TopbarProps {
  search: string;
  onSearchChange: (value: string) => void;
}

const Topbar = ({ search, onSearchChange }: TopbarProps) => {
  return (
    <div className="flex items-center gap-4 bg-white border border-gray-200 rounded-xl px-4 py-3 mb-6">
      <IconButton tone="muted">
        <PanelLeft size={20} />
      </IconButton>
      <div className="w-px h-5 bg-gray-200" />
      <div className="flex items-center gap-2 flex-1">
        <Search size={18} className="text-gray-400" />
        <Input
          variant="plain"
          value={search}
          onChange={onSearchChange}
          placeholder="Type to search..."
          containerClassName="flex-1 min-w-0"
          className="w-full outline-none text-sm text-gray-600 placeholder-gray-400"
        />
      </div>
      <IconButton tone="muted" className="relative">
        <Bell size={20} />
        <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-red-500 rounded-full" />
      </IconButton>
      <div className="w-9 h-9 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center text-xs font-medium text-gray-500">
        U
      </div>
    </div>
  );
};

export default Topbar;
